export default function LivraisonPlanifieeLivreeConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('livraison.planifiee.livree');
}

LivraisonPlanifieeLivreeConfiguration.$inject = ['$translatePartialLoaderProvider'];
